module.exports = __webpack_public_path__ + "static/media/logo.ef3ec057.png";